module.exports = __webpack_public_path__ + "img/u2011.ad3b5f76.png";